import { render, staticRenderFns } from "./BankIntegration.vue?vue&type=template&id=09fa7d48"
import script from "./BankIntegration.vue?vue&type=script&lang=js"
export * from "./BankIntegration.vue?vue&type=script&lang=js"
import style0 from "./BankIntegration.vue?vue&type=style&index=0&id=09fa7d48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports